<template>
  <svg
    id="Component_80_2"
    data-name="Component 80 – 2"
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    :class="{ enabled }"
  >
    <circle
      id="Ellipse_266"
      data-name="Ellipse 266"
      cx="16"
      cy="16"
      r="16"
      fill="#fafafa"
    />
    <path
      id="Path_2112"
      data-name="Path 2112"
      d="M15.528,7.147,1.447.107A1,1,0,0,0,0,1V6.2L9,7.55v1L0,9.9v5.182a1,1,0,0,0,1.447.894l14.081-7.04a1,1,0,0,0,0-1.789"
      transform="translate(8.959 7.958)"
      fill="#d2d7dc"
    />
  </svg>
</template>

<script>
export default {
  props: ['enabled'],
  name: 'Send',
}
</script>

<style lang="scss" scoped>
svg {
  path,
  circle {
    transition: all ease 0.3s;
  }
}
.enabled {
  circle {
    fill: $grass;
  }
  path {
    fill: white;
  }
}
</style>
